import { EventEmitter, Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogComponent } from "../common/confirm-dialog/confirm-dialog.component";
import { Department } from "../features/customer/customer.model";
import { v7 as uuidv7 } from 'uuid';

@Injectable({
    providedIn: 'root'
  })

  export class CommonService {

    // Company list changed
    public CompanyListChanged: EventEmitter<string> = new EventEmitter<string>();

    // Create customer update list..
    public CustomerListChanged: EventEmitter<string> = new EventEmitter<string>();

    // Database table added
    public DBTableAdded: EventEmitter<void> = new EventEmitter<void>();

    // Syncronisation contract created
    public SyncContractCreated: EventEmitter<void> = new EventEmitter<void>();

    // Department changed
    public DepartmentChanged: EventEmitter<Department> = new EventEmitter<Department>();

    /// Create Company Called
    public CreateCompany: EventEmitter<void> = new EventEmitter<void>();

    // Import Translations Called
    public ImportTranslations: EventEmitter<string> = new EventEmitter<string>();

    // Import Companies Called
    public ImportCompanies: EventEmitter<string> = new EventEmitter<string>();

    constructor(private modalService: NgbModal) { }

    public guidEmpty(): string {
        return '00000000-0000-0000-0000-000000000000';
    }

    public newUUID(): string {
      return uuidv7();
    }

    public confirm(
        title: string,
        message: string,
        btnOkText: string = 'Ok',
        btnCancelText: string = 'Cancel',
        dialogSize: 'sm'|'lg' = 'sm'): Promise<boolean> {
        const modalRef = this.modalService.open(ConfirmDialogComponent, { size: dialogSize, backdrop: 'static' });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;
    
        return modalRef.result;
     }

    // Message with a single OK button; an empty cancel text hides the cancel button.
    public async info(title: string, message: string, dialogSize: 'sm'|'lg' = 'lg'): Promise<void> {
        await this.confirm(title, message, 'Ok', '', dialogSize).catch(() => { });
    }
}
